import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { PortalAccessMode } from "@/types/employees/employee.types.ts";
import { Navigate, useParams } from "react-router-dom";

export function EsignRequestRedirect() {
  const { requestId } = useParams();
  const { data: employeeMe } = useEmployeeMe();

  const base =
    employeeMe && employeeMe.portal_access_mode !== PortalAccessMode.full
      ? "/preboarding"
      : "/home";

  const search = requestId ? `?modal=esign_request&id=${encodeURIComponent(requestId)}` : "";

  return <Navigate to={`${base}${search}`} replace />;
}
